if (!customElements.get('shipping-policy-drawer')) {
  customElements.define(
    'shipping-policy-drawer',
    class ShippingPolicyDrawer extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeyUp = this.handleKeyUp.bind(this);
        this.onVariantChange = this.enhanceOpeners.bind(this);
        this.hide = this.hide.bind(this);
      }

      connectedCallback() {
        this.panel = this.querySelector('.shipping-policy-drawer__panel');
        this.overlay = this.querySelector('[data-shipping-policy-drawer-overlay]');
        this.closeButton = this.querySelector('[data-shipping-policy-drawer-close]');
        this.policyUrl = this.normalizeUrl(this.dataset.policyUrl);

        this.closeButton?.addEventListener('click', this.hide);
        this.overlay?.addEventListener('click', this.hide);
        this.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('click', this.onDocumentClick);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }
        this.enhanceOpeners();

        if (!this.moved) {
          this.moved = true;
          document.querySelectorAll('shipping-policy-drawer').forEach((drawer) => {
            if (drawer !== this && drawer.parentElement === document.body) drawer.remove();
          });
          document.body.appendChild(this);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.variantChangeUnsubscriber?.();
      }

      enhanceOpeners() {
        document.querySelectorAll('.product__tax a[href]').forEach((link) => {
          if (!this.isPolicyLink(link)) return;
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', 'ShippingPolicyDrawer');
        });
      }

      isPolicyLink(link) {
        if (!this.policyUrl) return false;
        return this.normalizeUrl(link.getAttribute('href')) === this.policyUrl;
      }

      normalizeUrl(url) {
        if (!url) return '';
        try {
          return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
        } catch (e) {
          return String(url).replace(/\/$/, '');
        }
      }

      handleDocumentClick(event) {
        const link = event.target.closest?.('.product__tax a[href]');
        if (!link || !this.isPolicyLink(link)) return;

        // Keep real <a href> for SEO/crawlers and no-JS. Only intercept plain
        // primary clicks so modifier/middle-clicks can still open the policy page.
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        this.show(link);
      }

      handleKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      }

      show(focusElement) {
        this.focusElement = focusElement;
        // Match cart-drawer: timeout so the transform transition always runs
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        this.addEventListener(
          'transitionend',
          () => {
            trapFocus(this.panel, this.closeButton || this.panel);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }

      hide() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }
    }
  );
}
